import * as React from "react";
import { getCardBodyContent } from "@qlik/qlik/src/lib/util/helpers";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import * as styles from "./styles.module.css";

/**
 * ThankYouPage component
 * This component is displayed on succession of a redirection, download or form-submission
 * @returns {JSX.Element} - The rendered ThankYouPage component
 */

const ThankYouPage = ({ data }) => {
    const { cardItem, additionalConfiguration, customId } = data || {};
    const { title, cta } = cardItem ?? {};
    const bodyContent = getCardBodyContent(
        cardItem,
        `mt-7.5 ${styles.bodyContent} text-2xl font-light leading-relaxed tracking-tight6`
    );
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "py-20 lg:py-30");

    return (
        <section className={`${sectionSpacingClassName} contain-paint`} id={customId}>
            <div
                className="container relative
                            before:-z-1 before:content-[''] before:absolute before:w-[1408px] before:h-137.5 before:bg-thankYou before:bg-contain before:-top-72 before:-right-[1000px] 
                            lg:before:-top-[120px] lg:before:-right-[830px]"
            >
                <div className="row">
                    <div className="col-12 md:col-6">
                        {title && <h1 className="title-1">{title}</h1>}
                        {bodyContent && bodyContent}
                        {/* Rendering the CTA if it exists */}
                        {cta?.length > 0 && (
                            <div className="mt-2.5 flex flex-col lg:flex-row lg:flex-wrap items-center gap-x-5 lg:mt-7.5 lg:justify-start">
                                {cta?.map((button) => (
                                    <Cta key={button.id} data={button} className="mt-5" />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ThankYouPage;
